import BaseTemplate from '../../src/layouts/BaseTemplate'
import LoginView from '../../src/view/_public/LoginView';


import React, { Component } from 'react';

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.usernameRef = React.createRef()
  }

  componentDidMount = () => {
    // console.log("didmount")
    // this.usernameRef.focus()
  }

  render() {
    return (
      <BaseTemplate title="Login" body={<LoginView {...this.props} setRef={this.usernameRef} />} />
    );
  }
}